import { LimeModal } from "@/Components/NextBase/LimeModal";
import { api } from "@/lib/api-client";
import {
  Button,
  Link,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/react";
import { Trans } from "@lingui/react/macro";
import { useState } from "react";

export const YesterdayClosureWarningModal = ({
  businessPremiseId,
  posAuthUserId,
}: {
  businessPremiseId?: string;
  posAuthUserId?: number;
}) => {
  const [isDismissed, setIsDismissed] = useState(false);

  const { data: userPermissions, isFetching: isFetchingUserPermissions } =
    api.user.useGetUserPermissions({
      query: {
        tokenType: "POS",
      },
      disabled: !businessPremiseId || posAuthUserId == null,
    });

  const { data: cashRegisterHasClosedYesterday } =
    api.taxRegister.useGetCashRegisterHasClosedYesterday({
      businessPremiseId: businessPremiseId ?? "",
      disabled:
        !businessPremiseId ||
        !posAuthUserId ||
        isFetchingUserPermissions ||
        !userPermissions?.allow_closing_cash_register,
    });

  return (
    <LimeModal
      isOpen={!isDismissed && cashRegisterHasClosedYesterday === false}
      onClose={() => setIsDismissed(true)}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader>
              <p>
                <Trans>Zaključek blagajne</Trans>
              </p>
            </ModalHeader>
            <ModalBody>
              <Trans>
                Blagajna včeraj ni bila zaključena. Prosimo, da jo zaključite.
              </Trans>
            </ModalBody>
            <ModalFooter>
              <Button
                data-identifier="dismiss-yesterday-closure-warning-modal"
                onPress={onClose}
              >
                <Trans>Prekliči</Trans>
              </Button>
              <Button
                as={Link}
                href={`/dashboard/tax-register/cash-register/${businessPremiseId}/closure?openCustomPopover=true`}
                color="primary"
              >
                <Trans>Pojdi na zaključek</Trans>
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </LimeModal>
  );
};
